import { Component } from '@angular/core';
import { TCO } from '../../../../constants';
import { ProductQueueSearchCriteria } from '../../../../models/reservation-v2/criteria/product-queue-search-criteria';
import { MainType } from '../../../../models/reservation-v2/main-type';
import { ProductLevel } from '../../../../models/reservation-v2/product-level';
import { DataKey } from '../../../../services/util/framework/data-store.service';

@Component({
    selector: 'tc-product-queue-search-criteria-hotel',
    templateUrl: './product-queue-search-criteria-hotel.component.html'
})
export class ProductQueueSearchCriteriaHotelComponent {

    inputSearchCriteria = new ProductQueueSearchCriteria();
    searchCriteriaUpdatingDataKey = DataKey.productQueueSearchCriteria;
    searchResultsDataKey = DataKey.productQueueSearchResultsFromService;
    searchCriteriaLoadingDataKey = TCO.AppData.PRODUCT_QUEUE_SEARCH_CRITERIA_HOTEL;
    chipConfigKey = TCO.CONF.CONF_PRODUCT_QUEUE_SEARCH_CRITERIA_CHIP_HOTEL;
    paginationConfigKey = 'PRODUCT_QUEUE_SEARCH';
    placeHolderText = 'Search Hotel Products';

    createNewSearchCriteriaFn = () => {
        const criteria = new ProductQueueSearchCriteria();
        criteria.productLevel = ProductLevel.ANY;
        criteria.mainType = MainType.HTL;
        criteria.subType = 'ANY';
        return criteria;
    };

    clearLoadedSearchCriteriaFn = (searchCriteria: ProductQueueSearchCriteria) => {
        searchCriteria.productLevel = ProductLevel.ANY;
        searchCriteria.mainType = MainType.HTL;
        searchCriteria.subType = 'ANY';
    };
}
